// import { InventoryList } from '@/services/MockData/InventoryList/Inventory'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const INVENTORY_CONFIG = {
  INVENTORY: queryParams => ({
    endPoint: 'inventory?' + queryParams,
    // mockData: InventoryList,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use PRODUCTS_API_URL
    method: HTTP_METHODS.POST,
  }),
  INVENTORY_CSV_DOWNLOAD: queryParams => ({
    endPoint: 'inventory/export/csv?' + queryParams,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
  INVENTORY_UPLOAD_HISTORY: (type = 'INVENTORY') => ({
    endPoint: `file/metadata?templateType=${type}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
  INVENTORY_FILE_UPLOAD_ERRORS: (id, header) => ({
    endPoint: `file/${id}/process/errors`,
    method: HTTP_METHODS.GET,
    headers: {Accept: header ? header : 'application/json'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
}
